import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box, Typography, Button, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Chip, Stack, Fade,
} from '@mui/material';
import { ReceiptLong as ReceiptLongIcon, Add as AddIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

const STORAGE_KEY = 'receipts';

export default function ReceiptDetail() {
  const history = useHistory();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    try {
      setRows(JSON.parse(localStorage.getItem(STORAGE_KEY)) || []);
    } catch { setRows([]); }
  }, []);

  return (
    <Fade in timeout={400}>
      <Box sx={{ minHeight: '100vh', bgcolor: '#f7fafc', py: 6 }}>
        <Paper
          elevation={0}
          sx={{
            mb: 4, mx: { xs: 2, sm: 4, lg: 8 },
            background: 'linear-gradient(135deg,#10b981 0%,#047857 100%)',
            color: '#fff', p: { xs: 3, md: 4 }, borderRadius: 3,
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2}>
            <Stack direction="row" spacing={2} alignItems="center">
              <ReceiptLongIcon sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h4" fontWeight={700}>ใบเสร็จรับเงิน</Typography>
                <Typography sx={{ opacity: 0.85 }}>จัดการเอกสารใบเสร็จรับเงิน</Typography>
              </Box>
            </Stack>
            <Button
              variant="contained" color="secondary"
              startIcon={<AddIcon />}
              onClick={() => history.push('/sale/receipt/create')}
            >
              สร้างใบเสร็จรับเงิน
            </Button>
          </Stack>
        </Paper>

        <Box sx={{ mx: { xs: 2, sm: 4, lg: 8 } }}>
          <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 3 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#10b981' }}>
                  {['วันที่', 'เลขที่เอกสาร', 'ชื่อลูกค้า', 'ยอดสุทธิ', 'สถานะ'].map((h) => (
                    <TableCell key={h} sx={{ color: '#fff', fontWeight: 600 }}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={5} sx={{ py: 10, textAlign: 'center', color: 'text.secondary' }}>
                      <Stack alignItems="center" spacing={2}>
                        <ReceiptLongIcon sx={{ fontSize: 56, color: 'grey.400' }} />
                        <Typography variant="h6">ยังไม่มีข้อมูลใบเสร็จรับเงิน</Typography>
                        <Typography>กด "สร้างใบเสร็จรับเงิน" เพื่อเริ่มต้น</Typography>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ) : rows.map((r) => (
                  <TableRow key={r.id} hover sx={{ cursor: 'pointer' }}>
                    <TableCell>{r.date ? dayjs(r.date).locale('th').format('DD MMM YYYY') : '-'}</TableCell>
                    <TableCell>{r.billingNumber || '-'}</TableCell>
                    <TableCell>{r.customerName || '-'}</TableCell>
                    <TableCell>{Number(r.total || 0).toLocaleString('th-TH', { minimumFractionDigits: 2 })} ฿</TableCell>
                    <TableCell>
                      <Chip label={r.status || 'รอดำเนินการ'} color={r.status === 'ชำระแล้ว' ? 'success' : 'warning'} variant="outlined" size="small" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Fade>
  );
}
